
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FiX } from "react-icons/fi";
import CountdownTimer from "./countDownTimer";
import { getTrackingData } from "../../utils/trackingConfig";
import { searchSessionEnd } from "../../redux/slices/searchSlice";
import { useDispatch } from "react-redux";
const ActionModal = ({
  title,
  description,
  isVisible,
  onClose,
  onPressYes,
  eventSource,
  yesText,
  noText,
  extraData,
  extraMetaInfo,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //   const handleUpgrade = () => {
  //   onClose && onClose();

  //   const { event } = getTrackingData(eventSource);

  //   console.log("📊 Event:", event, {
  //     source: eventSource,
  //   });

  //   navigate("/profile/subscription", {
  //     state: { source: eventSource }, // ✅ VERY IMPORTANT
  //   });
  // };
  const handleUpgrade = () => {
    onClose && onClose();

    const session_id = sessionStorage.getItem("session_id");

    // Only trigger for SEARCH related sources
    const searchSources = ["city_detail_limit", "city_load_more_limit"];

    if (session_id && searchSources.includes(eventSource)) {
      dispatch(
        searchSessionEnd({
          session_id,
          led_to_upgrade: true,
          hit_daily_limit: true,
        })
      );

      // optional cleanup
      sessionStorage.removeItem("session_id");
    }

    const { event } = getTrackingData(eventSource);

    console.log("📊 Event:", event, {
      source: eventSource,
    });

    navigate("/profile/subscription", {
      state: { source: eventSource },
    });
  };
  // const handleUpgrade = () => {
  //   onClose && onClose();
  //   // redirect to your subscription route
  //   navigate("/profile/subscription");
  // };
  const handlerefer = () => {
    onClose && onClose();

    navigate("/referral");
  };

  return (
    <Modal
      show={isVisible}
      onHide={onClose}
      centered
      backdrop="static"
      dialogClassName="custom-modal logout-modal subscription-action-modal"
    >
      <Modal.Header>
        {/* <Modal.Title>Select Destination(s)</Modal.Title> */}
        <h5 className="modal-title">Subscription Required!</h5>
        <Button className="close-btn" onClick={onClose}>
          <FiX size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        {description ? (
          <p>{description}</p>
        ) : (
          <p>
            Your plan has expired. Subscribe now to unlock all the benefits.
          </p>
        )}
        {/* <p className="sub-title">{title}</p> */}
        {extraData ? (
          // <ul className="list-unstyled pt-2 mb-0 w-100 text-center">
          //   <li>{extraData && extraData.messageBody1}</li>
          //   <li>{extraData && extraData.messageBody2}</li>
          // </ul>
          <div className="action-content mt-1">
            <strong>{extraData && extraData.messageBody1}</strong>
            <p>{extraData && extraData.messageBody2}</p>
          </div>
        ) : (
          ""
        )}
        <div className="action-content mt-1">
          {description !== "Plus or Pro plan is required" && (
            <>
              <strong>Your limit resets in:</strong>
              <p>
                <CountdownTimer />
              </p>
            </>
          )}
        </div>

        {/* <p className="sub-title">{}</p> */}
        <div className="actions">
          <Button className="btn btn-secondary" onClick={handlerefer}>
            Refer & Earn Pro
          </Button>
          <Button className="btn btn-primary" onClick={handleUpgrade}>
            Upgrade Now
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ActionModal;
